<form class="signinTFAForm" [formGroup]="signinTFAForm" (ngSubmit)="submitTFA()">
    <div class="authorisationCode">
        <h4 *ngIf="placeholderText" class="pb-1">Passcode Required</h4>
        <p class="pb-2">{{placeholderText}}</p>
        <mat-form-field appearance="outline">
            <input matInput placeholder="Passcode" formControlName="tfaCode">
        </mat-form-field>
        <mat-error *ngIf="tfaCode.touched && tfaCode.errors?.required">
            Passcode is required
        </mat-error>
    </div>
    <button class="a-rounded-button a-rounded-button--primary" type="submit" [disabled]="signinTFAForm.invalid">Login</button>
</form>